import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import {
  adminDeactivateSupplement,
  adminSupplementInquiryDetails,
  adminSupplementRenew,
} from '@api/adminSupplements';
import {
  IAdminSupplementInquiryDetails,
  IAdminSupplementRenewPayload,
} from '@interfaces/adminSupplements';

export const handleGetAdminSupplementDetails = createAsyncThunk<
  AxiosResponse<IAdminSupplementInquiryDetails>,
  number
>('getAdminSupplementDetails', adminSupplementInquiryDetails);

export const handleAdminSupplementRenew = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminSupplementRenewPayload
>('adminSupplementRenew', adminSupplementRenew);

export const handleAdminDeactivateSupplement = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminDeactivateSupplement', adminDeactivateSupplement);
